<template>
  <v-menu ref="menu" v-model="menu" class="date-picker" close-on-click :close-on-content-click="false" min-width="290px" offset-y transition="scale-transition">
    <template #activator="{ attrs }">
      <div class="mf-date-range-picker-input-container" @click="menu = true">
        <mf-icon color="marca-0-l40" fill icon="event" />
        <span> {{ formattedDate }}</span>
      </div>
    </template>
    <v-date-picker v-model="computedAnalysedPeriod" data-cy="month-range-picker" locale="pt-BR" :max="max" :min="min" range @input="handleSelectDate" />
  </v-menu>
</template>

<script>
import { DateTime } from 'luxon'
export default {
  name: 'MonthRangePicker',
  props: {
    min: {
      type: String,
      default: '',
    },
    max: {
      type: String,
      default: '',
    },
    initialWeekday: {
      type: String,
      default: 'MONDAY',
    },
    analysedPeriod: {
      type: Array,
      default: () => ['', ''],
    },
  },
  data: () => ({
    menu: false,
    date: '',
  }),
  computed: {
    computedAnalysedPeriod: {
      get() {
        return this.analysedPeriod
      },
      set(value) {
        this.$emit('update:analysedPeriod', value)
      },
    },
    formattedDate() {
      if (!this.computedAnalysedPeriod[0]) return '00/00/0000 - 00/00/0000'
      const formatDate = (date) => DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('dd/MM/yyyy')

      return `${formatDate(this.computedAnalysedPeriod[0])} - ${formatDate(this.computedAnalysedPeriod[1])}`
    },
  },
  methods: {
    handleSelectDate(newDate) {
      const weekDays = {
        MONDAY: 1,
        TUESDAY: 2,
        WEDNESDAY: 3,
        THURSDAY: 4,
        FRIDAY: 5,
        SATURDAY: 6,
        SUNDAY: 7,
      }
      const selectedWeekDay = weekDays[this.initialWeekday]
      const selectedDate = DateTime.fromISO(newDate[0])
      const selectedDateWeekDay = selectedDate.weekday

      let diff = selectedDateWeekDay - selectedWeekDay
      if (diff < 0) diff += 7

      const startOfWeek = selectedDate.minus({ days: diff })
      const endOfWeek = startOfWeek.plus({ days: 6 })

      const formattedStartDate = startOfWeek.toFormat('yyyy-MM-dd')
      const formattedEndDate = endOfWeek.toFormat('yyyy-MM-dd')

      this.$emit('input', [formattedStartDate, formattedEndDate])
      this.computedAnalysedPeriod = [formattedStartDate, formattedEndDate]

      const formattedDateLabel = `${startOfWeek.toFormat('dd/MM/yyyy')} - ${endOfWeek.toFormat('dd/MM/yyyy')}`
      this.$emit('set-date', formattedDateLabel)

      this.menu = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-text-field__details {
  margin: 0 !important;
  padding: 0 !important;
}

#date-picker-icon {
  height: 24px;
}

.mf-date-range-picker-input-container {
  cursor: pointer;
  max-width: 340px;
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    color: $marca-0-l10;
    font-size: 18px;
    margin: 0;
    font-weight: 400;
    line-height: 1;
  }

  .separator {
    background: $marca-0-l40;
    height: 1px;
    width: 12px;
  }
}
</style>
